// extracted by mini-css-extract-plugin
export default {"page":"Lojas_page__mw4Vb","containerImg":"Lojas_containerImg__BeKf6","link":"Lojas_link__XffFN","pLink":"Lojas_pLink__O7Lsk","listarLojas":"Lojas_listarLojas__n68nw"};